export default "__VITE_ASSET__CNGiGoFg__"